/**
 * HowPointsWork — the event's standings rules in plain lines (points per
 * result, tie-breakers, net run rate, knockouts). They come from the rulebook,
 * the only place they are set; other screens show this box instead of a form.
 * `tone="dark"` sits on the navy Fixtures panel. Managers get "Edit in Rulebook".
 */
import { useSearchParams } from 'react-router-dom';

export default function HowPointsWork({ rules, tone = 'light', canEdit = false, testId = 'how-points-work' }) {
  const [, setSearchParams] = useSearchParams();
  if (!rules?.managed) return null;
  const dark = tone === 'dark';
  const openRulebook = () => {
    setSearchParams({ phase: 'rules' });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };
  return (
    <div className={`rounded-xl p-3.5 ${dark ? 'bg-white/10 text-white' : 'bg-[#E9EBF1]/60 text-[#2B3A67]'}`} data-testid={testId}>
      <div className="flex items-center justify-between gap-3">
        <div className="min-w-0">
          <p className="text-sm font-extrabold flex items-center gap-1.5 whitespace-nowrap">
            <i className="ph-bold ph-ranking" aria-hidden="true"></i>
            How points work
          </p>
          {rules.version && <p className={`text-[11px] font-semibold ${dark ? 'text-white/60' : 'text-gray-500'}`}>From the rulebook, version {rules.version}</p>}
        </div>
        {canEdit && (
          <button onClick={openRulebook}
            className={`shrink-0 text-xs font-bold px-2.5 py-1.5 rounded-lg ${dark ? 'bg-[#3AAFA9] text-white' : 'bg-white text-[#1F7A75] border border-[#3AAFA9]/40'}`}
            data-testid={`${testId}-edit`}>
            Edit in Rulebook
          </button>
        )}
      </div>
      <ul className={`mt-2 space-y-1 text-xs leading-relaxed ${dark ? 'text-white/85' : 'text-gray-700'}`}>
        {rules.lines.map((line) => (
          <li key={line} className="flex gap-2"><span aria-hidden="true" className={dark ? 'text-[#F4D341]' : 'text-[#3AAFA9]'}>•</span><span>{line}</span></li>
        ))}
      </ul>
      {(rules.min_matches || []).length > 0 && (
        <ul className={`mt-2 space-y-0.5 text-xs ${dark ? 'text-white/85' : 'text-[#B3263F]'}`} data-testid="min-matches-penalties">
          {rules.min_matches.map((m) => (
            <li key={m.team_id}>
              {m.team_name}: −{m.points_lost} pts (short of matches: {m.players_short.join(', ')})
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
